module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("This project would not have come to fruition without the generous assistance of a number of people. First and foremost, I would like to thank my adviser and mentor, David Frank, who encouraged me to take on this project. He listened to my initial pitches and offered great insight on the first two chapters of this book. I am grateful for his unfailing support of my research on Chinese rhetoric ever since I was in graduate school thirty years ago. I am equally grateful to Perry Link, a prominent China-studies scholar, who graciously agreed to read the draft of ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(" despite his busy schedule. His comments were extremely helpful, and his scholarly works on Chinese political language continue to be a source of inspiration. Moreover, I am indebted to a number of rhetorical scholars who have kindly provided helpful feedback on the manuscript. LuMing Mao read "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2")]), _vm._v(" on Mao’s theories of rhetoric; Herbert Simons read "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v(" on Mao’s rhetoric of class struggle; Mei Zhang read "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(" on rhetorical construction of a new Communist person; Michelle Yang read "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 7")]), _vm._v(" on Mao’s foreign policy rhetoric; Donovan Conley and Stephen Hartnett read and edited portions of the conclusion. I benefited from the expertise and research of each of these scholars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am grateful for the generous help I received from a number of individuals on collecting sources on Mao. Shensheng Zhao, a well-learned friend, kindly gave me two boxes of books on Mao and encouraged me to pursue the project before he passed away five years ago. Aizhen Li and Zhihong Xia, dear neighbors and scholars, purchased a number of books on Mao in China for me. Bertrand Chung from Taiwan offered me several of his private collections on Mao published in Taiwan. Weidong Tan directed me to some online resources regarding Mao that I would not have found otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have benefited from the two anonymous reviewers of this work. Their close and careful reading of the manuscript and their editorial suggestions for improvement were very helpful. The suggestion from one of the reviewers on the reorganization of the introduction helped unify the theme of transformative rhetoric in this book. I also extend my thanks to Jim Denton for his faith in me to complete this project and for his guidance in the review process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Special thanks go to Judy Bowker, my guardian angel and beloved friend, who read through and edited "), _c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01"
    }
  }, [_vm._v("chapters 1")]), _vm._v(" through the "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("conclusion")]), _vm._v(". As a rhetorician herself, "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("she asked thought-provoking questions, and her careful editing stimulated my thought process and improved the quality of the manuscript.")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This project was supported by DePaul University’s Research Council Paid Leave in 2013–14 and the College of Communication Summer Research Grant in the summer of 2011, which allowed me to be released from teaching and concentrate on research and writing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I owe gratitude to my daughter, Wendi Lulu Gu, and my husband, Licheng Gu, my two favorite cheerleaders. Since she was a baby Wendi has always watched me research Chinese rhetoric. Now that she has graduated from college and works as a literary agent at a literary agency, she has helped me with edits and asked me intellectually engaging questions throughout the process. Licheng has sacrificed his own time to cook and shop for me so that I could have more time to write. He also made many trips to the Northwestern University library on my behalf for books, as he is a faculty member of the university. Finally, my parents, who are both in their late eighties, are a continuous source of inspiration to me. They have supported me in more ways than they will ever know. Their lifelong experiences before and after China’s revolution in 1949 provide me with a real sense of China’s modern history and motivate me to learn more about Mao’s rhetoric. They both benefited and suffered under Mao’s authoritarian rule, and consequently they have mixed feelings about Mao. They will not be able to read this book, as it is written in English, but this work is tangible proof of their memory. This book is dedicated to them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cee967d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Acknowledgement.vue
// module id = 84
// module chunks = 0